var map = {
	"./BaseAmazonIcon.vue": 21868,
	"./BaseAnchorIcon.vue": 88956,
	"./BaseAppleIcon.vue": 36698,
	"./BaseArrowUpDownIcon.vue": 37141,
	"./BaseBellIcon.vue": 44869,
	"./BaseBookmarkIcon.vue": 18541,
	"./BaseBranchIcon.vue": 21186,
	"./BaseBriefcaseIcon.vue": 96504,
	"./BaseCalendarIcon.vue": 68199,
	"./BaseCameraIcon.vue": 33223,
	"./BaseChartIcon.vue": 34690,
	"./BaseCheckIcon.vue": 69923,
	"./BaseChevronDownIcon.vue": 11149,
	"./BaseClockIcon.vue": 8701,
	"./BaseCloseIcon.vue": 130,
	"./BaseCloseTinyIcon.vue": 51309,
	"./BaseCopyIcon.vue": 76754,
	"./BaseCursorClickIcon.vue": 4307,
	"./BaseDesktopIcon.vue": 3823,
	"./BaseDocumentIcon.vue": 8845,
	"./BaseDollarIcon.vue": 83433,
	"./BaseDoubleLeftIcon.vue": 31769,
	"./BaseDoubleRightIcon.vue": 96499,
	"./BaseDownIcon.vue": 94992,
	"./BaseDownloadIcon.vue": 52715,
	"./BaseEnvelopeIcon.vue": 76238,
	"./BaseErrorIcon.vue": 11416,
	"./BaseExclamationIcon.vue": 35933,
	"./BaseEyeCloseIcon.vue": 48045,
	"./BaseEyeIcon.vue": 64462,
	"./BaseFacebookIcon.vue": 39894,
	"./BaseFilledHeartIcon.vue": 47558,
	"./BaseGithubIcon.vue": 44173,
	"./BaseGlobeIcon.vue": 69661,
	"./BaseGoogleColor2Icon.vue": 36783,
	"./BaseGoogleColorIcon.vue": 15009,
	"./BaseGoogleIcon.vue": 72274,
	"./BaseGridIcon.vue": 34275,
	"./BaseHamburgerCloseIcon.vue": 36064,
	"./BaseHamburgerIcon.vue": 76108,
	"./BaseHeartIcon.vue": 98119,
	"./BaseIcon.vue": 48429,
	"./BaseImageIcon.vue": 9553,
	"./BaseInfoIcon.vue": 2421,
	"./BaseLeftIcon.vue": 98341,
	"./BaseLinkIcon.vue": 45990,
	"./BaseLinkedinIcon.vue": 65735,
	"./BaseLocaltionIcon.vue": 68428,
	"./BaseLockIcon.vue": 78540,
	"./BaseLogoutIcon.vue": 40985,
	"./BaseMenu2Icon.vue": 88825,
	"./BaseMenuIcon.vue": 42963,
	"./BaseMessageIcon.vue": 81072,
	"./BaseMinusIcon.vue": 33159,
	"./BaseMobileIcon.vue": 69214,
	"./BasePaperClipIcon.vue": 35590,
	"./BasePauseIcon.vue": 79698,
	"./BasePencilIcon.vue": 86984,
	"./BasePhoneIcon.vue": 87182,
	"./BasePlaneIcon.vue": 33346,
	"./BasePlay2Icon.vue": 23302,
	"./BasePlayIcon.vue": 97647,
	"./BasePlusIcon.vue": 93130,
	"./BaseProfileIcon.vue": 19068,
	"./BasePuzzleIcon.vue": 75952,
	"./BaseRefreshIcon.vue": 56185,
	"./BaseRightIcon.vue": 46845,
	"./BaseScalesIcon.vue": 50873,
	"./BaseSearchIcon.vue": 51804,
	"./BaseSettingsIcon.vue": 99716,
	"./BaseShieldIcon.vue": 95306,
	"./BaseShoppingCartIcon.vue": 43332,
	"./BaseSpeakerPhoneIcon.vue": 93696,
	"./BaseStarIcon.vue": 60279,
	"./BaseStarRatingIcon.vue": 6962,
	"./BaseStripeIcon.vue": 61750,
	"./BaseSuccessIcon.vue": 11259,
	"./BaseSupportIcon.vue": 38655,
	"./BaseTabletIcon.vue": 46782,
	"./BaseTemplateIcon.vue": 25075,
	"./BaseTrashIcon.vue": 23553,
	"./BaseTwitterIcon.vue": 19243,
	"./BaseUpIcon.vue": 68097,
	"./BaseUploadIcon.vue": 63867,
	"./BaseUsersIcon.vue": 75685,
	"./BaseVideoIcon.vue": 84436
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27980;